import '../style/portfolio.css';
import Carosal from './carousal';
import ProjectsShowcase from './projectdata';
import React from 'react';
import ReelGrid from './reelgrid';

export const PortfolioSection = () => {
  return (
    <div>
      <section className="portfolio-section">
        {/* Animated Header Section - Same as Packages */}
        <div className="portfolio-header">
          <div className="portfolio-header-background">
            <div className="portfolio-laser-ray portfolio-ray-1"></div>
            <div className="portfolio-laser-ray portfolio-ray-2"></div>
            <div className="portfolio-laser-ray portfolio-ray-3"></div>
            <div className="portfolio-laser-ray portfolio-ray-4"></div>
            <div className="portfolio-laser-ray portfolio-ray-5"></div>
            <div className="portfolio-laser-ray portfolio-ray-6"></div>
            <div className="portfolio-laser-ray portfolio-ray-7"></div>
            <div className="portfolio-laser-ray portfolio-ray-8"></div>
            <div className="portfolio-grid-pattern"></div>
            <div className="portfolio-pulse-effect"></div>
          </div>
          <div className="portfolio-header-content">
            <h2 className="portfolio-title">Our Portfolio</h2>
            <p className="portfolio-subtitle">Witness the magic of visual storytelling</p>
          </div>
        </div>
      </section>
      
      <div>
        <Carosal />
        <ProjectsShowcase />
        <ReelGrid />
      </div>
      
    </div>
  );
};

export default PortfolioSection;